module.exports = __webpack_public_path__ + "static/media/icon-control-point.1f4dc200.svg";